import styled from 'styled-components';

export const DenestImpcMappingStyle = styled.div`
.checkbox-true{
  width: 1005px;
  margin-left: calc(50% - 502.5px);
}
.checkbox-false{
  width: 980px;
  margin-left: calc(50% - 490px);
}
  @media only screen and (max-width:1899px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 553px;
    }
  }
  @media only screen and (min-width:1900px) and (max-width:1915px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 653px;
    }
  }

  @media only screen and (min-width:1916px) and (max-width:2135px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 653px;
    }
  }

  @media only screen and (min-width:2136px) and (max-width:2200px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 753px;
    }
  }

  @media only screen and (min-width:2201px) and (max-width:2400px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 853px;
    }
  }

  @media only screen and (min-width:2401px) and (max-width:2800px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 953px;
    }
  }

  @media only screen and (min-width:2801px) and (max-width:2900px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 1053px;
    }
  }

  @media only screen and (min-width:2901px) and (max-width:3200px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 1153px;
    }
  }

  @media only screen and (min-width:3201px) and (max-width:3900px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 1453px;
    }
  }

  @media only screen and (min-width:3901px){
    .generated-list {
      padding-bottom: 15px !important;
    }
    .fkTuFL {
      max-height: 2200px;
    }
  }
  .impc-button-container{
    margin-top: 10px;
    margin-bottom: -80px;
    text-align: left;
    margin-left: 45px;
    padding-bottom: 8px;
    position: relative;
    z-index:99;
    width: 520px;

    .impc-button {
      width: 125px;
      margin-left: 5px;
    }
  }
`;
